import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BsX } from 'react-icons/bs';
import { VscLaw } from 'react-icons/vsc';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { SET_SHOW_MODAL_LEGAL } from '../../actions/types';
import { PrivacyInformation, WebsiteTerms } from './LegalDocuments';
import './Modal.css';

function LegalModal() {
    const dispatch = useDispatch();
    const { showLegalModal, modalLegalType } = useSelector(state => state.appUI);
    const isTerms = modalLegalType === 'conditions';

    function closeModal() {
        dispatch({ type: SET_SHOW_MODAL_LEGAL, payload: { show: false, legalType: '' } });
    }

    return <Modal show={showLegalModal} onHide={closeModal} className="modal-fullscreen-custom">
        <Modal.Header className="text-center">
            <Col className="d-flex justify-content-start">
                <Button onClick={closeModal} variant="link" className="dark-a" aria-label="Zavřít">
                    <BsX size={25} />
                </Button>
            </Col>
            <Col md="auto" className="text-center">
                <Row className="justify-content-md-center">
                    <Col md="auto" className="my-auto"><VscLaw size={30} /></Col>
                    <Col md="auto" className="header-col">
                        <h3 className="fw-light">
                            {isTerms ? 'Všeobecné obchodní podmínky' : 'Informace o zpracování osobních údajů'}
                        </h3>
                    </Col>
                </Row>
            </Col>
            <Col />
        </Modal.Header>
        <Modal.Body className="legal-body">
            {isTerms ? <WebsiteTerms /> : <PrivacyInformation />}
        </Modal.Body>
    </Modal>;
}

export default LegalModal;
